// mv-slider
const swiper = new Swiper(".mv-swiper", {
  slidesPerView: 1,
  speed: 1800,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    390: {
      slidesPerView: 1.2,
      spaceBetween: 20,
      centeredSlides: true,
    },
    787: {
      slidesPerView: 1.3,
      spaceBetween: 20,
      centeredSlides: true,
    },
    1600: {
      slidesPerView: 1.7,
      spaceBetween: 40,
      centeredSlides: true,
    }
  }
});



// top-pickup-swiper
const pickupSwiper = new Swiper(".pickup-swiper", {
  loop: false,
  spaceBetween: 8,
  slidesPerView: 1.5,
  grid: {
    rows: 2,
    fill: 'row'
  },
  breakpoints: {
    788: {
      slidesPerView: 1,
      grid: {
        rows: 1
      },
      spaceBetween: 15,
    }
  }
});





//top-recommend
const recommendSwiper = new Swiper(".recommend-product", {
  loop: true,
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next.swiper-button-next--recommend",
    prevEl: ".swiper-button-prev.swiper-button-prev--recommend",
  },
  slidesPerView: 3,
  slidesPerGroup: 3,
  breakpoints: {
    788: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    }
  },
  on: {
    init: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--recommend");
    },
    slideChange: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--recommend");
    }
  }
});

function togglePrevButton(swiper, prevButtonSelector) {
  const prevButton = document.querySelector(prevButtonSelector);
  if (swiper.realIndex === 0) {
    prevButton.style.display = "none";
  } else {
    prevButton.style.display = "";
  }
}



//top-product
const productSwiper = new Swiper(".list-product", {
  loop: true,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper-button-next.swiper-button-next--products",
    prevEl: ".swiper-button-prev.swiper-button-prev--products",
  },
  slidesPerView: 3,
  slidesPerGroup: 3,
  breakpoints: {
    788: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    }
  },
  on: {
    init: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--products");
    },
    slideChange: function (swiper) {
      togglePrevButton(swiper, ".swiper-button-prev--products");
    }
  }
});


// //top-banner
const bannerswiper = new Swiper('.js-bannerSwiper', {
  loop: true,
  slidesPerView: 1.5,
  spaceBetween: 15,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});


//top-new
document.querySelectorAll(".new-product").forEach(function(el) {
  const section = el.closest(".top-new");
  new Swiper(el, {
    spaceBetween: 15,
    pagination: {
      el: section.querySelector(".swiper-pagination.swiper-pagination--new"),
      clickable: true,
    },
    navigation: {
      nextEl: section.querySelector(".swiper-button-next.swiper-button-next--new"),
      prevEl: section.querySelector(".swiper-button-prev.swiper-button-prev--new"),
    },
    slidesPerView: 3,
    slidesPerGroup: 3,
    freeMode: true,
    breakpoints: {
      390: {
        slidesPerView: 2.3,
        slidesPerGroup: 2,
      },
      788: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      }
    }
  });
});


//top-outlet
const outletSwiper = new Swiper(".outlet-product", {
  spaceBetween: 15,
  pagination: {
    el: ".swiper-pagination.swiper-pagination--outlet",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next.swiper-button-next--outlet",
    prevEl: ".swiper-button-prev.swiper-button-prev--outlet",
  },
  slidesPerView: 3,
  slidesPerGroup: 3,
  freeMode: true,
  breakpoints: {
    390: {
      slidesPerView: 2.3,
      slidesPerGroup: 2,
    },
    788: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    }
  }
});

// top-ranking：タブ切り替え＋SPスライダー
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.top-ranking').forEach(function (section) {
    const tabs = section.querySelectorAll('nav.ranking__nav a');
    const panels = section.querySelectorAll('ul.panel > li');

    /**
     * 表示中のランキングパネルだけSwiperを初期化する
     */
    function initRankingSwiper(panel) {
      if (!panel || window.innerWidth > 787) return;

      const slider = panel.querySelector('.products-wrapper.swiper');
      if (!slider) return;

      const offsetAfter = Math.round(slider.clientWidth * 0.3);

      // 初期化済みの場合は表示幅を再計算
      if (slider.swiper) {
        slider.swiper.params.slidesOffsetAfter = offsetAfter;
        slider.swiper.updateSize();
        slider.swiper.updateSlides();
        slider.swiper.updateProgress();
        slider.swiper.update();
        return;
      }

      new Swiper(slider, {
        slidesPerView: 2.3,
        slidesPerGroup: 2,
        spaceBetween: 4,
        loop: false,
        freeMode: true,
        watchOverflow: true,

        // 非表示→表示の変化も監視
        observer: true,
        observeParents: true,

        // No.10を完全に表示できる後方余白
        slidesOffsetAfter: offsetAfter
      });
    }

    /**
     * タブとパネルを切り替える
     */
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();

        tabs.forEach(function (item) {
          item.classList.remove('on');
          item.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('on');
        });

        tab.classList.add('on');
        tab.setAttribute('aria-selected', 'true');

        const activePanel = panels[index];

        if (activePanel) {
          activePanel.classList.add('on');

          // display:blockが反映されてから幅を取得
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              initRankingSwiper(activePanel);
            });
          });
        }
      });
    });

    // 最初から表示されているパネルを初期化
    const initialPanel =
      section.querySelector('ul.panel > li.on') || panels[0];

    if (initialPanel) {
      initRankingSwiper(initialPanel);
    }
  });
});